import { Config, GeolocationServices } from '@constants';
import { RootState } from '@state/index.ts';
import { setUserIp } from '@state/reducers/geoComply.ts';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mutate } from 'swr';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketPlayerAuthInfoWatcher() {
  const { getLatest } = useSocket();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state);
  const changed = getLatest('auth_info');
  const isGeoComplyEnabled =
    window.__config__.componentSettings?.geolocationSettings?.service ===
    GeolocationServices.GeoComply;
  const lastEventKeyRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (changed) {
      // @ts-ignore
      const eventKey = `${changed.action}:${changed.data?.player_id ?? 'unknown'}`;

      if (lastEventKeyRef.current === eventKey) return;
      lastEventKeyRef.current = eventKey;
      // @ts-ignore
      if (
        !!Config.geoComplyKey &&
        isGeoComplyEnabled &&
        state.geoComply &&
        // @ts-ignore
        changed.data?.user_ip &&
        // @ts-ignore
        state.geoComply?.userIp !== changed.data.user_ip
      ) {
        // @ts-ignore
        dispatch(setUserIp(changed.data.user_ip));
      }
    }
  }, [dispatch, changed, isGeoComplyEnabled, state.geoComply]);

  return null;
}
